module.exports =
  accepted: ["circle", "square"]
  value:    false
